<template>
<section class="premium-section">
<h2 class="section-title">Estimated MDR Reward Balance System</h2>

<p>
The Mudra platform uses an estimated reward balance system to provide creators with real-time visibility of their accumulated rewards.
</p>

<p>
Estimated MDR balances represent the total reward amount earned by creators based on verified content submissions on the platform.
</p>

<p>
These balances are tracked within the platform before being converted into on-chain token allocations.
</p>

<p>
By maintaining reward balances off-chain during the active reward phase, Mudra ensures operational efficiency while providing creators with transparent reward tracking.
</p>

<p>
Creators can monitor their estimated rewards directly from their dashboard as they continue contributing original content.
</p>

</section>
</template>